// import React, { useContext, useRef, useState } from "react";
// import upwardarrow from "../../assests/Upwardarrow/upwardArrow.svg";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import logo from "../../assests/paperlogo.png";
// import Swal from "sweetalert2";
// import { GlobalStateContext } from "../../App";
// import { AiFillFileImage, AiOutlineClose } from "react-icons/ai";

// const UploadLogoButton = ({ text, style, stage, stateChanger, btnID, disabled, getEmail }) => {
//   const navigator = useNavigate();
//   const { globalState, setGlobalState } = useContext(GlobalStateContext);
//   const [galleryView, setGalleryView] = useState(false);

//   const convertBase64 = (file) => {
//     return new Promise((resolve, reject) => {
//       const fileReader = new FileReader();
//       fileReader.readAsDataURL(file);

//       fileReader.onload = () => {
//         resolve(fileReader.result);
//       };

//       fileReader.onerror = (error) => {
//         reject(error);
//       };
//     });
//   };

//   const getLocation = () => {
//     if (parseInt(stage) == 2 || parseInt(stage) == 5) {
//       switch (btnID) {
//         case "upload_1":
//           return "t1Logo";
//         case "upload_2":
//           return "t2Logo";
//         case "upload":
//           return "rhsBG";
//       }
//     } else return "logo";
//   };

//   const save2gallery = (event) => {
//     const image = event.target.files[0];

//     if (typeof image == "undefined") return;

//     if (image.type == "image/png") {
//       const img = new Image();
//       img.onload = () => {
//         const body = new FormData();
//         body.append("image", image);

//         const headers = {
//           Authorization: "Bearer " + localStorage.getItem("access_token"),
//         };

//         const maxDifference =
//           parseInt(stage) == 2
//             ? 300
//             : parseInt(stage) == 5 || parseInt(stage) == 4
//             ? 300
//             : parseInt(stage) == 3
//             ? 0
//             : 50; // You can adjust this threshold as needed

//         const width = img.width;
//         const height = img.height;
//         const difference = Math.abs(width - height);

//         const uploadImage = () => {
//           fetch(
//             "https://friendly-jepsen.77-68-82-89.plesk.page/gallery/" +
//               globalState?.userData?._id,
//             { method: "POST", headers, body }
//           )
//             .then((res) => res.json())
//             .then(({ doc }) => {
//               var globalStateClone = Object.assign({}, globalState);
//               globalStateClone.gallery = [doc, ...globalState.gallery];
//               setTimeout(() => {
//                 setGlobalState(globalStateClone);
//               }, 3000);
//               if (btnID === "all") {
//                 navigator("/customizer?stage=0", { state: doc.url });
//                 // navigator("/home");
//               } else {
//                 stateChanger(getLocation(), doc.url, stage + 1);
//                 setGalleryView(false);
//               }
//             });
//         };

//         if (difference <= maxDifference) uploadImage();
//         else {
//           Swal.fire({
//             icon: "warning",
//             title: "Image resolution warning",
//             text:
//               parseInt(stage) == 3
//                 ? `Please upload a circular logo with same height and width.`
//                 : `The difference between width and height of the image should be less than ${maxDifference}px for perfect placement.`,
//           }).then(uploadImage);
//         }
//       };
//       img.src = URL.createObjectURL(image);
//     } else {
//       Swal.fire({
//         icon: "error",
//         title: "File Type Error!",
//         text: "only png type file is acceptable",
//       });
//     }
//   };

//   const uploadImage = async (event) => {
//     const file = event.target.files[0];

//     if (typeof file == "undefined") return;

//     if (file.type == "image/png") {
//       const img = new Image();
//       img.src = URL.createObjectURL(file);

//       img.onload = () => {

//         const maxDifference =
//           parseInt(stage) == 2
//             ? 300
//             : parseInt(stage) == 5 || parseInt(stage) == 4
//             ? 300
//             : parseInt(stage) == 3
//             ? 0
//             : 50; // You can adjust this threshold as needed

//         const width = img.width;
//         const height = img.height;
//         const difference = Math.abs(width - height);

//         if (difference <= maxDifference) {

//           convertBase64(file)
//             .then((base64) => {
//               // console.log("4: converted to base64", { base64 });
//               // alert("stage 4")
//               if (btnID === "all") {
//                 // navigator("/customizer?stage=0", { state: base64 });
//                 navigator("/home", { state: base64 } );
//               } else {
//                 stateChanger(getLocation(), base64, stage);
//               }
//             })
//             .catch((error) => {
//               console.error("Error converting to base64:", error);
//             });
//         } else {
//           Swal.fire({
//             icon: "warning",
//             title: "Image resolution warning",
//             text:
//               parseInt(stage) == 3
//                 ? `Please upload a circular logo with same height and width.`
//                 : `The difference between width and height of the image should be less than ${maxDifference}px for perfect placement.`,
//           });
//           convertBase64(file)
//             .then((base64) => {
//               if (btnID === "all") {
//                 // navigator("/customizer?stage=0", { state: base64 });
//                 navigator("/home", { state: base64 } );
//               } else {
//                 stateChanger(getLocation(), base64, stage);
//               }
//             })
//             .catch((error) => {
//               console.error("Error converting to base64:", error);
//             });
//           console.error(
//             `The difference between width and height of the image should be less than ${maxDifference}px.`
//           );
//         }
//       };

//       img.onerror = (error) => {
//         console.error("Error loading image:", error);
//       };

//       event.target.value = "";
//     } else {
//       Swal.fire({
//         icon: "error",
//         title: "File Type Error!",
//         text: "only png type file is acceptable",
//       });
//     }
//   };

//   return (
//     <>
// {galleryView && (
//   <div className="absolute top-[50%] left-[50%] w-[60vw] h-[80vh] translate-x-[-50%] translate-y-[-50%] bg-[#fff] rounded-[30px] z-50 overflow-y-scroll no-scrollbar drop-shadow-2xl">
//     <nav className="w-full flex flex-row justify-between items-center px-10 mt-6">
//       <h3 className="text-[30px]">Upload Image</h3>
//       <button
//         className="text-xl cursor-pointer hover:bg-gray hover:text-black rounded-full p-[8px]"
//         onClick={() => setGalleryView(false)}
//       >
//         <AiOutlineClose />
//       </button>
//     </nav>
//     <input
//       className="cursor-pointer"
//       type="file"
//       style={{ display: "none" }}
//       accept="image/png"
//       id={btnID}
//       onChange={save2gallery}
//     />
//     <label
//       htmlFor={btnID}
//       className="w-[200px] aspect-square border-2 border-dotted border-[#0e5e5e] rounded-lg flex flex-col items-center justify-center mx-auto my-8 cursor-pointer"
//     >
//       <AiFillFileImage className="text-[80px] mb-5 text-[#0e5e5e]" />
//       <div className="bg-[#0e5e5e] text-white px-5 py-3 rounded-lg">
//         Upload your Image
//       </div>
//     </label>
//     <div className="px-10 py-5">
//       <h4 className="text-left">Recents Uploads</h4>

//       <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
//         {globalState.gallery.map(({ url }) => (
//           <img
//             className="border-[7px] border-[#0e5e5e50] rounded-md"
//             src={url}
//             onClick={() => {
//               if (btnID === "all") {
//                 navigator("/customizer?stage=0", { state: url });
//               } else {
//                 stateChanger(getLocation(), url, stage);
//               }
//               setGalleryView(false);
//             }}
//           />
//         ))}
//       </div>
//     </div>
//   </div>
// )}
//       <div className="cursor-pointer transition-transform duration-300 hover:scale-110">
//         <input
//           className="cursor-pointer"
//           type="file"
//           style={{ display: "none" }}
//           accept="image/png"
//           id={btnID}
//           onChange={(e) => {
//             if (!globalState?.userData) uploadImage(e);
//           }}
//           disabled={disabled}
//         />
//         <label
//           htmlFor={btnID}
//           className={`rounded-[40px] ${getEmail ? "bg-[#dbdbdb]  text-black" : "bg-black  text-white"} flex flex-row items-center p-1 ${style}`}
//           onClick={(e) => {
//             if (globalState?.userData) {
//               e.preventDefault();
//               setGalleryView(true);
//             }
//           }}
//         >
//           <p
//             className={" mx-5 text-[18px] " + (disabled ? " cursor-not-allowed" : " cursor-pointer")}
//             style={{ fontFamily: "ZapfHumanistBold" }}
//           >
//             {text}
//           </p>
//           <div className="rounded-full h-8 w-8 bg-white flex justify-center p-1 cursor-pointer">
//             <img
//               className="w-4 h-4 mt-1 cursor-pointer"
//               src={upwardarrow}
//               alt="Upward Arrow"
//             />
//           </div>
//         </label>
//       </div>
//     </>
//   );
// };
// export default UploadLogoButton;

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

import React, { useContext, useState } from "react";
import upwardarrow from "../../assests/Upwardarrow/upwardArrow.svg";
import { AiFillFileImage, AiOutlineClose } from "react-icons/ai";
import Swal from "sweetalert2";
import { GlobalStateContext } from "../../App";
import { useNavigate } from "react-router-dom";

const UploadLogoButton = ({
  text,
  style,
  stage,
  stateChanger,
  btnID,
  disabled,
  getEmail,
}) => {
  const navigator = useNavigate();
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const [galleryView, setGalleryView] = useState(false);

  const isUserLogedin = globalState?.userData ? true : false;

  const uploadToGallery = (file) => {
    return new Promise((resolve, reject) => {
      const body = new FormData();
      body.append("image", file);

      const headers = {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      };
      fetch(
        "https://friendly-jepsen.77-68-82-89.plesk.page/gallery/" +
          globalState?.userData?._id,
        { method: "POST", headers, body }
      )
        .then((res) => res.json())
        .then(({ doc }) => {
          const { url } = doc;
          setGlobalState(state=>{
            const gallery = [...state.gallery, doc]
            return {
              ...state, gallery
            }
          })
          resolve(url);
        });
    });
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const getLocation = () => {
    if (parseInt(stage) === 2 || parseInt(stage) === 5) {
      switch (btnID) {
        case "upload_1":
          return "t1Logo";
        case "upload_2":
          return "t2Logo";
        case "upload":
          return "rhsBG";
        default:
          return "logo";
      }
    } else return "logo";
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    handleFileUpload(file);
  };

  const handleFileUpload = (file) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const maxDifference =
        parseInt(stage) === 2
          ? 300
          : parseInt(stage) === 5 || parseInt(stage) === 4
          ? 300
          : parseInt(stage) === 3
          ? 0
          : 50; // You can adjust this threshold as needed

      const width = img.width;
      const height = img.height;
      const difference = Math.abs(width - height);

      if (difference > maxDifference)
        Swal.fire({
          icon: "warning",
          title: "Image resolution warning",
          text:
            parseInt(stage) == 3
              ? `Please upload a circular logo with same height and width.`
              : `The difference between width and height of the image should be less than ${maxDifference}px for perfect placement.`,
        });

      const uploader = isUserLogedin ? uploadToGallery : convertBase64;
      uploader(file)
        .then((base64) => {
          stateChanger(getLocation(), base64, stage);
        })
        .catch((error) => {
          console.error("Error converting to base64:", error);
        });
    };

    img.onerror = (error) => {
      console.error("Error loading image:", error);
    };
  };

  return (
    <>
      {galleryView && (
        <div className="absolute top-[50%] left-[50%] w-[60vw] h-[80vh] translate-x-[-50%] translate-y-[-50%] bg-[#fff] rounded-[30px] z-50 overflow-y-scroll no-scrollbar drop-shadow-2xl">
          <nav className="w-full flex flex-row justify-between items-center px-10 mt-6">
            <h3 className="text-[30px]">Upload Logos</h3>
            <button
              className="text-xl cursor-pointer hover:bg-gray hover:text-black rounded-full p-[8px]"
              onClick={() => setGalleryView(false)}
            >
              <AiOutlineClose />
            </button>
          </nav>
          <input
            className="cursor-pointer"
            type="file"
            style={{ display: "none" }}
            accept="image/png"
            id={btnID}
            onChange={handleFileChange}
          />
          <label
            htmlFor={btnID}
            className="w-[200px] aspect-square border-2 border-dotted border-[#0e5e5e] rounded-lg flex flex-col items-center justify-center mx-auto my-8 cursor-pointer"
          >
            <AiFillFileImage className="text-[80px] mb-5 text-[#0e5e5e]" />
            <div className="bg-[#0e5e5e] text-white px-5 py-3 rounded-lg">
              UPLOAD LOGO
            </div>
          </label>
          <div className="px-10 py-5">
            <h4 className="text-left">Recents Uploads</h4>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {console.log(globalState.gallery, "thisssssss")}
              {globalState.gallery.map(({ url }) => (
                <img
                  key={url} // Add a key to each image for React to identify them uniquely
                  className="border-[7px] border-[#0e5e5e50] rounded-md"
                  src={url}
                  alt="Recent Upload"
                  onClick={() => {
                    if (btnID === "all") {
                      navigator("/home", { state: url });
                    } else {
                      stateChanger(getLocation(), url, stage);
                    }
                    setGalleryView(false);
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="cursor-pointer transition-transform duration-300 hover:scale-110">
        <input
          type="file"
          style={{ display: "none" }}
          accept="image/png"
          id={btnID}
          onChange={handleFileChange}
          disabled={disabled}
        />
        <label
          htmlFor={btnID}
          className={`rounded-[40px] ${
            getEmail ? "bg-[#dbdbdb]  text-black" : "bg-black  text-white"
          } flex flex-row items-center p-1 ${style}`}
          onClick={(e) => {
            if (isUserLogedin) {
              e.preventDefault();
              setGalleryView(true);
            }
          }}
        >
          <p
            className={`mx-5 text-[18px] ${
              disabled ? " cursor-not-allowed" : " cursor-pointer"
            }`}
            style={{ fontFamily: "ZapfHumanistBold" }}
          >
            {text}
          </p>
          <div className="rounded-full h-8 w-8 bg-white flex justify-center p-1 cursor-pointer">
            <img
              className="w-4 h-4 mt-1 cursor-pointer"
              src={upwardarrow}
              alt="Upward Arrow"
            />
          </div>
        </label>
      </div>
    </>
  );
};

export default UploadLogoButton;
